/* vf-ar-fixes.js — Arabic storefront only (loaded from layout/theme.liquid when request.locale is ar).
   1. Money: Hyper's cart, cart drawer and price filter print the shop format "EGP 43,900"; the Arabic cards already show
      "43,900 ج.م" (snippets/price.liquid). Text nodes "EGP 43,900" become "43,900 ج.م" everywhere, including content the
      cart re-renders later.
   2. Review app (Yozo) widgets live in open shadow roots and ship English strings; known phrases are translated there.
   3. Breadcrumb "Home" (app breadcrumb on the product page) becomes "الرئيسية".
   Text nodes only (never inputs, scripts or attributes); a MutationObserver per root keeps later renders fixed. */
(function () {
  'use strict';
  var D = document;
  if (!/^ar/i.test(D.documentElement.lang || '')) return;

  var MONEY = /EGP\s*([\d][\d,.]*)/g;
  var PHRASES = [
    [/^Loved by our customers$/i, 'آراء عملائنا'],
    [/^No reviews yet$/i, 'لسه مفيش تقييمات'],
    [/^Be the first to review this product\.?$/i, 'كن أول من يقيّم المنتج ده'],
    [/^Write a review$/i, 'اكتب تقييمك'],
    // review counts stay "5 reviews" in English (owner, 2026-10-30)
    [/^Verified( buyer)?$/i, 'مشتري موثّق']
  ];
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION|CODE|PRE)$/;
  var seen = new WeakSet();

  function fixText(node, inApp) {
    var v = node.nodeValue, t = v.trim(), out = v;
    if (!t) return;
    if (t.indexOf('EGP') > -1) out = out.replace(MONEY, '$1 ج.م');
    if (inApp) {
      for (var i = 0; i < PHRASES.length; i++) {
        if (PHRASES[i][0].test(t)) { out = out.replace(t, t.replace(PHRASES[i][0], PHRASES[i][1])); break; }
      }
    }
    if (t === 'Home') {
      var p = node.parentElement;
      if (p && p.closest('[class*="breadcrumb"], nav[aria-label*="read"]')) out = out.replace('Home', 'الرئيسية');
    }
    if (out !== v) node.nodeValue = out;
  }

  function walk(root, inApp) {
    var tw = D.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.nodeType === 1 && SKIP.test(n.tagName) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
    });
    for (var n = tw.currentNode; n; n = tw.nextNode()) {
      if (n.nodeType === 3) fixText(n, inApp);
      else if (n.shadowRoot) watch(n.shadowRoot, inApp || /^YOZO-/i.test(n.tagName));
    }
  }

  function watch(root, inApp) {
    walk(root, inApp);
    if (seen.has(root)) return;
    seen.add(root);
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        if (m.type === 'characterData') fixText(m.target, inApp);
        for (var j = 0; j < m.addedNodes.length; j++) {
          var a = m.addedNodes[j];
          if (a.nodeType === 3) fixText(a, inApp);
          else if (a.nodeType === 1 && !SKIP.test(a.tagName)) walk(a, inApp || /^YOZO-/i.test(a.tagName));
        }
      }
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }

  function start() { watch(D.body, false); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
  // app widgets attach their shadow roots after load: sweep again a few times
  [1500, 4000, 9000].forEach(function (ms) { setTimeout(function () { walk(D.body, false); }, ms); });
})();
